import { render, staticRenderFns } from "./ClientsExternal.vue?vue&type=template&id=109aed29&"
import script from "./ClientsExternal.vue?vue&type=script&lang=js&"
export * from "./ClientsExternal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('109aed29')) {
      api.createRecord('109aed29', component.options)
    } else {
      api.reload('109aed29', component.options)
    }
    module.hot.accept("./ClientsExternal.vue?vue&type=template&id=109aed29&", function () {
      api.rerender('109aed29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientsExternal.vue"
export default component.exports